import API from '@/config/api';
import axios from 'axios';

export const GET_CONSTANTS = () => axios.get(API.constants);

export const GET_REPORTS = (params = {}) => axios.get(API.reports, { params });